import { render, staticRenderFns } from "./q1.vue?vue&type=template&id=40fdfd9c&scoped=true"
import script from "./q1.vue?vue&type=script&lang=js"
export * from "./q1.vue?vue&type=script&lang=js"
import style0 from "./q1.vue?vue&type=style&index=0&id=40fdfd9c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fdfd9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40fdfd9c')) {
      api.createRecord('40fdfd9c', component.options)
    } else {
      api.reload('40fdfd9c', component.options)
    }
    module.hot.accept("./q1.vue?vue&type=template&id=40fdfd9c&scoped=true", function () {
      api.rerender('40fdfd9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionTemplates/q1.vue"
export default component.exports